export const DEFAULT_ACCOUNT_VISIT_TYPE_ID = 'custom_regular_visit';

export const buildDefaultVisitTypeConfiguration = (clinicId: string) => ({
  clinic_id: clinicId,
  default_type: 'visit',
  visit_types: [
    {
      type_id: DEFAULT_ACCOUNT_VISIT_TYPE_ID,
      name: 'Regular Visit',
      name_ar: 'كشف عادي',
      normal_price: 400,
      urgent_price: 400,
      is_active: true,
      order: 1
    }
  ]
});
